export enum FarmType {
  SowGiltPigletFattening = 10,
  SowPiglet = 20,
  Fattening = 40,
  SowPigletGilts = 30,
  Goat = 50,
  Cow = 60,
  Calf = 70,
  Unknown = 0
}

export enum BusinessUnitType {
  Farm = 1,
  Veterinary = 2
}
